//Imports
import React, { useContext, useEffect, useState } from "react";
import Select, { components } from "react-select";
//Import Context
import { DepartmentContext } from "../../contexts/DepartmentContext";
//Import Components
import ViewRequest from "./ViewRequest";
import ViewPayment from "./ViewPayment";
import MessageConfirmation from "../messageConfirmation/MessageConfirmation";
//Import Helpers 
import { formatCurrency, formatDisplayName, getSubventionNames } from "../../shared/helpers";
//Import Icons
import filters from '../../assets/icons/filters.svg';
import documentIcon from '../../assets/icons/document.svg';
//Import CSS
import './viewPendingRequests.css';

function ViewPendingRequests({
    setView,
    pendingRequests,
    userData,
    establishmentList,
    pmeList,
    projectId,
    requestObserved,
    answerObservation,
    data,
    selectedRequest,
    setSelectedRequest,
    departmentName,
    view,
    viewObserved,
    viewResponseObservation,
    currentRequestType,
    setCurrentRequestType }) {
    const { messageConfirmation, showNotificationDepartment } = useContext(DepartmentContext);
    const [selectedEstablishment, setSelectedEstablishment] = useState({
        value: null,
        label: 'Todos los establecimientos'
    });
    const [filteredRequests, setFilteredRequests] = useState([]);
    const [confirmationMessage, setConfirmationMessage] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const [hasPaymentRequests, setHasPaymentRequests] = useState(false);

    //Effects
    useEffect(() => {
        const contenedor = document.querySelector('.container-department'); // o tu clase principal scrollable
        if (contenedor) contenedor.scrollTop = 0;
    }, []);

    useEffect(() => {
        // setSelectedRequest(null);
        filterRequests();
    }, [currentRequestType, selectedEstablishment, pendingRequests]);

    useEffect(() => {
        // Verificar si existen solicitudes de pago
        const paymentRequests = pendingRequests.some(request => request.typeOfRequest === 'payment');
        setHasPaymentRequests(paymentRequests);
    }, [pendingRequests]);

    useEffect(() => {
        filterRequests();
    }, [currentRequestType, selectedEstablishment, pendingRequests]);

    const filterRequests = () => {
        try {
            let filtered = [];

            // Asegurarse de que pendingRequests existe y es un array
            if (pendingRequests && Array.isArray(pendingRequests)) {
                // Filtrar por tipo de solicitud
                filtered = pendingRequests.filter(request => request.typeOfRequest === currentRequestType);

                // Filtrar por establecimiento si es necesario
                if (userData?.dimension === 'Establecimiento') {
                    filtered = filtered.filter(request => request.idEstablishment === userData?.establishmentId);
                } else if (selectedEstablishment?.value !== null) {
                    filtered = filtered.filter(request => request.idEstablishment === selectedEstablishment.value);
                }
            }

            setFilteredRequests(filtered);
        } catch (error) {
            console.error("Error al filtrar solicitudes:", error);
            setFilteredRequests([]);
        }
    };

    const getEstablishmentOptions = () => {
        const establishments = establishmentList
            .filter(establishment => establishment.projectId === projectId)
            .map(establishment => ({
                value: establishment.id,
                label: establishment.nameEstablishment
            }));

        // Agregar la opción "Todos los establecimientos" al inicio del array
        return [
            { value: null, label: 'Todos los establecimientos' },
            ...establishments
        ];
    };

    const handleEstablishmentChange = (selectedOption) => {
        setSelectedEstablishment(selectedOption || {
            value: null,
            label: 'Todos los establecimientos'
        });
    };

    const handleRequestTypeChange = (type) => {
        try {
            // Desmontar cualquier componente de visualización activo
            if (selectedRequest) {
                setSelectedRequest(null);
            }
            // Limpiar la lista filtrada para evitar referencias a datos antiguos
            setFilteredRequests([]);
            // Usar setTimeout para asegurar que las limpiezas se completen primero
            setTimeout(() => {
                // Cambiar el tipo de solicitud después de limpiar
                setCurrentRequestType(type);
            }, 0);
        } catch (error) {
            console.error("Error al cambiar el tipo de solicitud:", error);
            // En caso de error, intentar un cambio más directo
            setCurrentRequestType(type);
        }
    };

    const getEstablishmentName = (idEstablishment) => {
        const establishment = establishmentList.find(establishment => establishment.id === idEstablishment);
        return establishment ? establishment.nameEstablishment : 'No encontrado';
    };

    const getActivityDetails = (idPME, idActivity) => {
        const pme = pmeList.find(pme => pme.id === idPME);
        if (pme) {
            const activity = pme.activities.find(act => act.id === idActivity);
            if (activity) {
                return {
                    actionName: activity.nameOfAction,
                    subvention: activity.subsidies,
                    pmeAmount: activity.totalSubsidyAmount,
                    fullActivity: activity
                };
            }

        }
        return { actionName: 'No encontrado', subvention: 'No encontrado', pmeAmount: 'No encontrado', fullActivity: null };
    };

    const handleViewRequest = (request) => {
        const { fullActivity } = getActivityDetails(request.idPME, request.idActivity);
        const activity = fullActivity;
        setSelectedRequest({ request: request, activity });
    };

    const handleRequestResponse = (success) => {
        if (success) {
            showNotificationDepartment(true, 'sendRequest');
            setErrorMessage(null);
            setSelectedRequest(null);
        } else {
            setErrorMessage("Error al enviar la respuesta");
            setConfirmationMessage(null)
        };
        setSelectedRequest(null);
    };

    return (
        <section className={`view-pending-requests flex ${selectedRequest ? 'without-scroll' : ''}`}>
            {(userData?.permissions === 'admin' || userData?.dimension === 'Sostenedor') && (
                <article className='box-filter flex'>
                    <span className='input-select flex'>
                        <label htmlFor='establishment' className='hidden-label'>Filtrar por Establecimiento</label>
                        <Select
                            name='establishment'
                            id='establishment'
                            options={getEstablishmentOptions()}
                            placeholder='Filtrar por establecimiento'
                            className='custom-select'
                            classNamePrefix='custom-select'
                            components={{ DropdownIndicator }}
                            onChange={handleEstablishmentChange}
                            value={selectedEstablishment.value}
                        />
                    </span>
                </article>
            )}
            <article className='pending-requests flex'>
                <nav className='nav-requests flex'>
                    <ul className='requests-type flex'>
                        <li
                            className={`request-tab ${currentRequestType === 'purchase' ? 'active' : ''}`}
                            onClick={() => handleRequestTypeChange('purchase')}
                        >
                            Solicitudes de Compra
                        </li>
                        <li
                            className={`request-tab ${currentRequestType === 'serviceContract' ? 'active' : ''}`}
                            onClick={() => handleRequestTypeChange('serviceContract')}
                        >
                            Solicitudes Contratos de Servicios
                        </li>
                        <li
                            className={`request-tab ${currentRequestType === 'feeContract' ? 'active' : ''}`}
                            onClick={() => handleRequestTypeChange('feeContract')}
                        >
                            Solicitudes Contratos de Honorarios
                        </li>
                        {hasPaymentRequests && (
                            <li
                                className={`request-tab ${currentRequestType === 'payment' ? 'active' : ''}`}
                                onClick={() => handleRequestTypeChange('payment')}
                            >
                                Solicitud de Pago
                            </li>
                        )}
                    </ul>
                </nav>
                <span className='table-container flex'>
                    <table className='table-requests'>
                        <thead>
                            <tr>
                                <th>Establecimiento</th>
                                <th>Nombre de la Acción</th>
                                <th>Subvención</th>
                                <th>Monto PME</th>
                                <th>Monto Solicitud</th>
                                <th>Ver Solicitud</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentRequestType !== 'payment' ? (
                                filteredRequests.length > 0 ? (
                                    filteredRequests.map((request) => {
                                        const establishmentName = getEstablishmentName(request.idEstablishment);
                                        const { actionName, subvention, pmeAmount } = getActivityDetails(request.idPME, request.idActivity);
                                        return (
                                            <tr key={request.id}>
                                                <td data-label='Establecimiento'>{formatDisplayName(establishmentName)}</td>
                                                <td data-label='Nombre de la Acción'>{formatDisplayName(actionName)}</td>
                                                <td data-label='Subvención'>{getSubventionNames(subvention)}</td>
                                                <td data-label='Monto PME'>{formatCurrency(pmeAmount)}</td>
                                                <td data-label='Monto Solicitud'>{formatCurrency(request.requestDetails?.requestAmount)}</td>
                                                <td data-label='Ver Solicitud'>
                                                    <button type='button' className='button' onClick={() => { handleViewRequest(request) }}>
                                                        <img src={documentIcon} className='icon' alt='Icono para ver solicitud' />
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan='6'>No Existen Solicitudes</td>
                                    </tr>
                                )
                            ) : (
                                filteredRequests.length > 0 ? (
                                    filteredRequests.map((request) => {
                                        const establishmentName = getEstablishmentName(request.idEstablishment);
                                        const { actionName, subvention, pmeAmount } = getActivityDetails(request.idPME, request.idActivity);
                                        return (
                                            <tr key={request.id}>
                                                <td>{formatDisplayName(establishmentName)}</td>
                                                <td>{formatDisplayName(actionName)}</td>
                                                <td>{getSubventionNames(subvention)}</td>
                                                <td>{formatCurrency(pmeAmount)}</td>
                                                <td>{formatCurrency(request?.amountToBePaid)}</td>
                                                <td>
                                                    <button type='button' className='button' onClick={() => { handleViewRequest(request) }}>
                                                        <img src={documentIcon} className='icon' alt='Icono para ver solicitud' />
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan='6'>No Existen Solicitudes</td>
                                    </tr>
                                )
                            )


                            }
                        </tbody>
                    </table>
                </span>

            </article>
            <article className={`box-actions flex ${selectedRequest ? 'not-show' : ''}`}>
                <button type='button flex' className='button' onClick={() => setView(false)}>Volver</button>
            </article>
            {selectedRequest && (
                currentRequestType === 'payment' ? (
                    <ViewPayment
                        request={selectedRequest}
                        setSelectedRequest={setSelectedRequest}
                        onRequestResponse={handleRequestResponse}
                        requestObserved={requestObserved}
                        answerObservation={answerObservation}
                        data={data}
                        departmentName={departmentName}
                        view={view}
                        viewObserved={viewObserved}
                        viewResponseObservation={viewResponseObservation}
                        currentRequestType={currentRequestType}
                    />

                ) : (
                    <ViewRequest
                        request={selectedRequest}
                        setSelectedRequest={setSelectedRequest}
                        onRequestResponse={handleRequestResponse}
                        requestObserved={requestObserved}
                        answerObservation={answerObservation}
                        data={data}
                        departmentName={departmentName}
                        view={view}
                        viewObserved={viewObserved}
                        viewResponseObservation={viewResponseObservation}
                        currentRequestType={currentRequestType}
                    />
                )

            )}
            <MessageConfirmation
                confirmation={messageConfirmation}
                error={errorMessage}
                view={true}
            />
        </section>
    );
};

const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <img src={filters} alt="CustomArrow" />
        </components.DropdownIndicator>
    );
};

export default ViewPendingRequests;